import { createActions, CreatedActions } from 'reduxsauce';

const { Types, Creators }: CreatedActions = createActions({
  checkToken: ['token'],
  setTokenVerifiedStatus: ['tokenVerifiedStatus'],
  setIsLoading: ['isLoading'],
  clearData: null,
});

export { Types as EmailVerificationTypes, Creators as EmailVerificationActions };
